export default "__VITE_ASSET__16f942b3__"